export default function GetAmericanOddsDescription() {
    return (
        <>
            <p>
                The <b>getAmericanOdds</b> function returns the value of the
                rawOdds in american format
            </p>
            <div>
                The input parameter is an object with the following required
                properties:
                <ol>
                    <li>
                        <b>rawOdds</b>: the value of the odds coming from the
                        APIs (usually the decimal odds multiplied by 1000)
                    </li>
                    <li>
                        <b>OddsMap</b>: An odds conversion table that allow
                        client side odds conversions to american or fractional
                        format. The Kambi client uses the map from
                        "/offering/oddsLadder" endpoint of the offering API
                        OddsMap should be an object with keys the name of the
                        format in which you want to convert the rawOdds.
                        Possible values:
                        <ul>
                            <li>decimal</li>
                            <li>american</li>
                            <li>fractional</li>
                        </ul>
                        The values for these keys should be an array containing
                        arrays of pairs [rawOdd, fractional/american/decimal
                        value] where <b>rawOdd</b> is the value coming from the
                        API and the next element of the array is the
                        corresponding value in <b>american format</b>
                    </li>
                </ol>
            </div>
            <div>
                The expected output is a string with the american odds with the
                following compute rules:
                <ol>
                    <li>
                        RawOdds converted to a string when the input rawOdds are
                        less than 1000
                    </li>
                    <li>
                        When rawOdds are over 2000 we use this formula:
                        Math.round(rawOdds / 10 - 100)
                    </li>
                    <li>
                        When rawOdds are between 1000 and 2000 we use the{' '}
                        <b>OddsMap</b> provided as input to find the equivalent
                        of the rawOdds in american format
                    </li>
                </ol>
            </div>
        </>
    );
}
